var React = require('react');

function RegisterCheckIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"29.9998","cy":"30","r":"25.2","fill":"#00C8A9","key":0}),React.createElement("path",{"d":"M55.0199 23.8289L39.6094 39.6586L33.5996 33.6362","stroke":"black","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("line",{"x1":"15.2002","y1":"24.4","x2":"36.4002","y2":"24.4","stroke":"black","strokeWidth":"4","strokeLinecap":"round","key":2}),React.createElement("line",{"x1":"15.2002","y1":"35.2","x2":"24.4002","y2":"35.2","stroke":"black","strokeWidth":"4","strokeLinecap":"round","key":3})]);
}

RegisterCheckIcon.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = RegisterCheckIcon;

RegisterCheckIcon.default = RegisterCheckIcon;
